import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import StripePayment from "../stripe-payment/StripePayment";
import CheckoutCard from "./CheckoutCard";
import { useWeb3Context } from "../../context/UseWeb3Context";

export const PRODUCT_NAME = "Physical T-Shirt";

export const PRODUCT_PRICE = 100;

const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || ""
);

const Checkout = () => {
  const { account } = useWeb3Context();

  const [clientSecret, setClientSecret] = useState("");
  const { state } = useLocation();
  const { quantity, size, mintForMe } = state;

  const [items] = useState([
    {
      id: new Date(),
      name: PRODUCT_NAME,
      price: PRODUCT_PRICE,
      quantity: quantity,
      size,
      mintForMe: mintForMe,
    },
  ]);
  const TOTAL = items[0].price * quantity || 0;
  const pushOrderDetails = (paymentIntentId) => {
    axios
      .post("/create-order", {
        account: account,
        amount: TOTAL,
        currency: "USD",
        quantity,
        total: TOTAL,
        size,
        mintDate: new Date().toLocaleString(),
        paymentIntentId: paymentIntentId,
        mintForMe,
      })
      .then((res) => console.log({ res }));
  };

  useEffect(() => {
    axios
      .post("/create-payment-intent", {
        items,
      })
      .then((response) => {
        if (response.status === 200) {
          setClientSecret(response.data.client_secret);
          pushOrderDetails(response.data.paymentIntentId);
        }
      })
      .catch((error) => {
        // console.log({ error });
      });
  }, [items]);

  const appearance = {
    theme: "light",
  };
  const options = {
    clientSecret,
    appearance,
  };

  return (
    <Box padding={12}>
      <Grid container spacing={2} column={9}>
        <Grid item xs={12} md={6}>
          {items &&
            items.length > 0 &&
            items.map(({ id, name, price, quantity }) => {
              return (
                <React.Fragment key={id}>
                  { mintForMe && <CheckoutCard
                    name={name}
                    amount={price}
                    quantity={quantity}
                    isMintForMe={mintForMe}
                  />}
                   { !mintForMe && <CheckoutCard
                    name={name}
                    amount={price}
                    quantity={quantity}
                    size={size}
                    isMintForMe={mintForMe}
                  />}
                </React.Fragment>
              );
            })}
        </Grid>

        <Grid item xs={12} md={6}>
          <Box sx={{ position: "relative" }}>
            <Typography variant="h5">Total : {TOTAL}&nbsp;USD</Typography>
            {clientSecret === "" ? (
              <CircularProgress
                sx={{
                  position: "absolute",
                  top: "9rem",
                  left: "8rem",
                }}
                variant="indeterminate"
              />
            ) : (
              <Elements options={options} stripe={stripePromise}>
                <StripePayment clientSecret={clientSecret} />
              </Elements>
            )}
          </Box>
        </Grid>

        <Grid item xs={2}>
          {" "}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Checkout;
